import styled from '@emotion/styled';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING, ZINDEX } from '../../../../styles/emotion';
import { ButtonV3 } from '../../../ButtonV3';
import CloseIcon from '../../../SvgIcons/Close';

export const MobileOverlay = styled.div`
  ${MEDIA_QUERY.MOBILE_XS} {
    position: fixed;
    height: 100vh;
    width: 100vw;
    overflow-x: hidden;
    overflow-y: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: ${ZINDEX.super};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const MobileHeader = styled.div`
  display: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    display: block;
  }
  border-bottom: 1px solid ${COLORS.BLACK_030};
  text-align: center;
  padding: 20px 0;
  font-size: ${FONT.FONT_SIZE_REGULAR};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;

export const CloseButton = styled(ButtonV3)`
  display: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    display: block;
    position: absolute;
    right: 16px;
    top: 16px;
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  color: ${COLORS.BLACK_100};
`;

export const ListBoxContainer = styled.div<{
  width: number | string;
  align: string;
  isHoverTrigger?: boolean;
  mobileOverlay: boolean;
}>`
  cursor: pointer;
  // Remove margin when isHoverTrigger is true because we'll be applying padding to DropdownTrigger InputSection
  margin-top: ${({ isHoverTrigger }) => (isHoverTrigger ? null : SPACING.XS)};
  border: 1px solid ${COLORS.BLACK_030};
  border-radius: ${SPACING.XS};
  background-color: ${COLORS.WHITE_100};
  position: absolute;
  z-index: 20;
  max-height: 300px;
  overflow: auto;
  ${({ width }) => `width: ${width}`};

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    ${({ align }) => {
      switch (align) {
        case 'right':
          return `
            right: 0;
          `;
        case 'center':
          return `
          left: 50%;
          transform: translateX(-50%);
        `;
        default:
          return `
            left: 0;
          `;
      }
    }}
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    position: fixed;
    width: 100%;
    top: ${(p) => (p.mobileOverlay ? null : 0)};
    bottom: ${(p) => (p.mobileOverlay ? 0 : null)};
    left: 0;
    margin: 0;
    border: none;
    height: ${(p) => (p.mobileOverlay ? 'fit-content' : '100vh')};
    max-height: none;
    border-radius: ${SPACING.S16} ${SPACING.S16} 0 0;
  }
`;

export const ListBox = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    padding: 12px 6px;
  }
`;

export const MobileCtaSection = styled.div`
  display: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    display: block;
  }
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.1);
  border-top: 1px solid ${COLORS.BLACK_030};
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 12px 14px 20px;
  background-color: ${COLORS.WHITE_100};
`;
